import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { FormHelperText, Grid, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import * as yup from "yup";

import Button from "../../components/Button";
import logo from "../../assets/images/logo.svg";
import Logo from "../../components/Logo";
import Paper from "../../components/Paper";
import Background from "../../components/Background";
import ConfirmationModal from "../../components/ConfirmationModal";
import { LoginTextField } from "../../components/LoginTextField";
import { sendPasswordResetLink } from "../../api/password";
import { errorCodes } from "../../constants/errors";
import { routes } from "../../api/paths";
import MetaDecorator from "../../components/MetaDecorator";

const passwordSchema = yup.object({
  email: yup
    .string()
    .required("Upišite email.")
    .email("Unesite ispravan email."),
});

export default function PasswordReset() {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [noSuchUserError, setNoSuchUserError] = useState("");
  const history = useHistory();

  return (
    <>
      <MetaDecorator />
      <Background>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={8} lg={3}>
            <Paper>
              <Logo src={logo} />
              <Typography variant="h4" style={{ margin: 20 }}>
                Reset lozinke
              </Typography>
              <Formik
                initialValues={{ email: "" }}
                validationSchema={passwordSchema}
                onSubmit={async (values) => {
                  try {
                    await sendPasswordResetLink(values);
                    setModalOpen(true);
                  } catch (error: any) {
                    if (
                      error.response &&
                      error.response.status === errorCodes.NOT_FOUND
                    ) {
                      setNoSuchUserError(
                        "Unijeli ste pogrešan ili nepostojeći email."
                      );
                    }
                  }
                }}
              >
                {({ handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <LoginTextField
                      id="email"
                      label="Unesite email"
                      name="email"
                      type="email"
                    />
                    {noSuchUserError && (
                      <FormHelperText error={true}>
                        {" "}
                        {noSuchUserError}{" "}
                      </FormHelperText>
                    )}
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Pošalji link
                    </Button>
                  </Form>
                )}
              </Formik>
            </Paper>
          </Grid>
        </Grid>
        <ConfirmationModal
          modalOpen={modalOpen}
          handleClose={() => {
            history.push(routes.LOGIN_URL);
          }}
          modalText={
            "Provjerite svoj email inbox i kliknite na link koji ste dobili za ponovno postavljanje lozinke."
          }
          title={"Link je na putu!"}
        />
      </Background>
    </>
  );
}
